import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

function isBrowserView() {
  return window.matchMedia('(display-mode: browser)').matches;
}

if (!isBrowserView()) {
  console.log('The application is running in a standard browser view.');
  
  window.addEventListener('visibilitychange', function () {
    console.log('Visibility changed');
    if (document.visibilityState === 'visible') {
      console.log('APP resumed');
      window.location.reload();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
